
$(document).ready(function () { 
    // Detect request animation frame
    var scroll = window.requestAnimationFrame ||
        // IE Fallback
        function (callback) { window.setTimeout(callback, 1000 / 60) };
   // var elementsToShow = document.querySelectorAll('.show-on-scroll');

    var theLogo = $("#thelogo");
    var newImage = new Image();
    newImage.src = theLogo.attr("src");
    var imgWidth = newImage.width;
    // distance over which zoom effect takes place
    var maxScrollDistance = 1600;
    // set to window height if larger
    maxScrollDistance = Math.min(maxScrollDistance, $(window).height());

    // width at maximum zoom out (i.e. when window has scrolled maxScrollDistance)
    var widthAtMax = 600;

    if (screen.width > 1600) {
        var widthAtMax = 680;
    };
    // calculate diff and how many pixels to zoom per pixel scrolled
    var widthDiff = imgWidth - widthAtMax;
    var pixelsPerScroll = (widthDiff / maxScrollDistance);

    function scrollImages() {
        var scrollTopPos = Math.min($(document).scrollTop(), maxScrollDistance);

        // how many pixels to adjust by
        var scrollChangePx = Math.floor(scrollTopPos * pixelsPerScroll);
        // calculate the new width
        var zoomedWidth = imgWidth - scrollChangePx;
        // set the width
       // this.console.log(zoomedWidth);
        $('.lksep19bnrtext').css("opacity", 1 - $(window).scrollTop() / 700);
        $('.lksep19bnrimg').css('width', zoomedWidth);
    }
    //$(document).ready(function () { scrollImages(); })

    $(window).on('scroll', function () {
        // the currently scrolled-to position - max-out at maxScrollDistance

        scrollImages(); 
       // $(window).off('scroll');
    });
 
    function isElementInViewport(el) {
        // special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        var rect = el.getBoundingClientRect();
        return (
            (rect.top <= 0
                && rect.bottom >= 0)
            ||
            (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.top <= (window.innerHeight || document.documentElement.clientHeight))
            ||
            (rect.top >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
        );
    }
});